<template>
    <div :class="['brand-centre', {'brand-centre--open': showBrandCentre}]">
        <h2 class="brand-centre__heading">My Brand Centre</h2>

        <FormulateInput
            v-model="projectID"
            :options="availableProjects"
            type="select"
            label="Project description"
            placeholder="Select a Project"
            :outer-class="['brand-centre__outer-select-wrapper']"
            :wrapper-class="['formulate-input-wrapper--select']"
            :element-class="['brand-centre__select-wrapper', {'brand-centre__select-wrapper--with-value' : projectID}]"
            :label-class="['formulate-input-label--select-bold']"
            @input="changeProject(projectID)"
        >
            <template slot="suffix" v-if="projectID">
                <div class="brand-centre__select-cross-wrapper" @click="removeProject(projectID)">
                    <InlineSvg :src="require(`../../assets/svgs/close.svg`)" class="brand-centre__select-cross"/>
                </div>
            </template>
        </FormulateInput>

        <div class="brand-centre__panels-wrapper">
            <Panel
                :header="'Word Bank (' + wordBank.length + ')'"
                :toggleable="true"
                :collapsed.sync="isWordBankCollapsed"
                ref="wordBankPanel"
                :class="[{'p-panel--collapsed': isWordBankCollapsed}, {'p-panel--extended': isBrandBankCollapsed}]"
            >
                <div class="brand-centre__pills-container">
                    <span
                        v-for="(word, index) in wordBank"
                        :key="index"
                        :class="[
                            'brand-centre__pill',
                            'brand-centre__pill--green',
                            'ui-draggable',
                            'ui-draggable-handle',
                            {'brand-centre__pill--active': wordPills.some(item => (item.value === word.name && item.colorClass === 'drag-drop-input__pill--green'))}
                        ]"
                        @click.self="addWordBankPillToInput(word.name)"
                    >
                        {{ word.name }}
                        <InlineSvg :src="require(`../../assets/svgs/close.svg`)" class="brand-centre__pill-cross" @click="removeWordBankWord(word)"/>
                    </span>
                </div>
            </Panel>

            <Panel
                :header="'Brand Bank (' + brandBank.length + ')'"
                :toggleable="true"
                :collapsed.sync="isBrandBankCollapsed"
                ref="brandBankPanel"
                :class="[{'p-panel--collapsed': isBrandBankCollapsed}, {'p-panel--extended': isWordBankCollapsed}]"
            >
                <div class="brand-centre__pills-container">
                    <span
                        v-for="(brandName, index) in brandBank"
                        :key="index"
                        :class="[
                            'brand-centre__pill',
                            'brand-centre__pill--blue',
                            'ui-draggable',
                            'ui-draggable-handle',
                            {'brand-centre__pill--active': wordPills.some(item => (item.value === brandName.name && item.colorClass === 'drag-drop-input__pill--blue'))}
                        ]"
                        @click.self="addBrandBankPillToInput(brandName.name)"
                    >
                        {{ brandName.name }}
                        <InlineSvg :src="require(`../../assets/svgs/close.svg`)" class="brand-centre__pill-cross" @click="removeBrandBankWord(brandName)"/>
                    </span>
                </div>
            </Panel>
        </div>

        <button class="brand-centre__close-button" @click="toggleBrandCentreVisibility">
            Hide
            <InlineSvg :src="require(`../../assets/svgs/close-v1.svg`)" class="brand-centre__close-icon" />
        </button>

        <button class="brand-centre__open-tab" @click="toggleBrandCentreVisibility">
            <p>My Brand Centre</p>
        </button>
    </div>
</template>

<script>
    import $ from 'jquery';
    import 'jquery-ui/dist/jquery-ui.min';
    import InlineSvg from 'vue-inline-svg';
    import Panel from 'primevue/panel';
    import { mapActions, mapGetters } from 'vuex';
    import { nextTick } from 'vue';

    export default {
        name: 'BrandCentre',
        components: {
            InlineSvg,
            Panel,
        },
        mounted() {
            nextTick(() => {
                this.makeComponentsDraggable();
            });
        },
        data() {
            return {
                projectID: '',
                isWordBankCollapsed: false,
                isBrandBankCollapsed: false,
            }
        },
        computed: {
            ...mapGetters('BrandCentre', {
                showBrandCentre: 'getBrandCentreVisibility',
                wordBank: 'getWordBankWords',
                brandBank: 'getBrandBankWords',
                currentProject: 'getCurrentProject',
                availableProjects: 'getAvailableProject',
            }),
            ...mapGetters('BrandChecker', {
                brandNamePills: 'getBrandNamePills',
            }),
            ...mapGetters('BrandCreator', {
                searchWordPills: 'getSearchWordPills',
            }),
            currentPath: function() {
                return this.$route.path;
            },
            wordPills: function() {
                /*
                    Switch between create and check selected pills based on current path.
                    This allows us to apply the active class to the correct pills in each tool
                */
                if (this.currentPath === '/brand-creator') {
                    return this.searchWordPills;
                }

                return this.brandNamePills;
            }
        },
        watch: {
            wordBank() {
                // when new words are added make them draggable
                nextTick(() => {
                    this.makeComponentsDraggable();
                });
            },
            brandBank() {
                // when new words are added make them draggable
                nextTick(() => {
                    this.makeComponentsDraggable();
                });
            },
            currentProject() {
                if (this.currentProject) {
                    this.projectID = this.currentProject.value;
                }
            }
        },
        methods: {
            ...mapActions('BrandCentre', [
                'removeWordBankWord',
                'removeBrandBankWord',
                'changeCurrentProject',
                'deleteProject',
                'toggleBrandCentreVisibility'
            ]),
            ...mapActions('BrandChecker', [
                'addBrandNamePill',
                'resetBrandNamePills'
            ]),
            ...mapActions('BrandCreator', [
                'addSearchWordPill',
                'resetSearchWordPills'
            ]),
            makeComponentsDraggable() {
                $('.brand-centre__pill').draggable({
                    cancel: '.brand-centre__pill--active',
                    helper: 'clone',
                });
            },
            addWordBankPillToInput(word) {
                if (this.currentPath === '/brand-creator') {
                    this.addSearchWordPill({
                        value: word,
                        colorClass: 'drag-drop-input__pill--green'
                    });
                } else if (this.currentPath === '/brand-checker') {
                    this.addBrandNamePill({
                        value: word,
                        colorClass: 'drag-drop-input__pill--green'
                    });
                }
            },
            addBrandBankPillToInput(brandName) {
                if (this.currentPath === '/brand-creator') {
                    this.addSearchWordPill({
                        value: brandName,
                        colorClass: 'drag-drop-input__pill--blue'
                    });
                } else if (this.currentPath === '/brand-checker') {
                    this.addBrandNamePill({
                        value: brandName,
                        colorClass: 'drag-drop-input__pill--blue'
                    });
                }
            },
            removeProject(projectID) {
                this.$confirm.require({
                    message: 'Are you sure you want to delete this project?',
                    header: 'Delete Confirmation',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        //callback to execute when user confirms the action
                        this.deleteProject(projectID);
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            },
            changeProject(projectID) {
                if (projectID) {
                    this.changeCurrentProject(projectID);
                    // this.resetSearchWordPills();
                    // this.resetBrandNamePills();
                }
            }
        }
    }
</script>